import React, { forwardRef } from 'react';

/**
 * FooterProgress
 * Sticky bottom footer showing time remaining and per-section progress bars.
 * The root element exposes a ref so useLayoutMetrics can measure its height.
 */
const FooterProgress = forwardRef(function FooterProgress(
  { timeRemainingText = '', sectionProgress = [], prefersReducedMotion = false },
  ref
) {
  return (
    <div className="fixed left-0 right-0 bottom-0 bg-white border-t-2 border-gray-200 px-4 py-3" ref={ref}>
      <div className="w-full px-6 md:px-10">
        <div className="w-full md:w-1/2 mx-auto">
          <div className="text-xs text-gray-700 mb-2 text-centre font-semibold">
            {timeRemainingText}
          </div>
        </div>
      </div>
      <div className="flex gap-2 w-full px-6 md:px-10">
        <div className="w-full md:w-1/2 mx-auto flex gap-2">
          {(sectionProgress || []).map((p, i) => (
            <div key={i} className="flex-1 bg-tertiary rounded-full h-3 overflow-hidden">
              <div
                className={`bg-primary h-3 ${prefersReducedMotion ? '' : 'transition-all duration-300'}`}
                style={{ width: `${p}%` }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default FooterProgress;


